module.exports = __webpack_public_path__ + "static/media/inoutimage.771ab42b.svg";